import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../api';
import type { PaymentPollingDto } from '../../generated-api';

export const usePollPaymentStatusList = (
  paymentReferences: string[],
  enabled: boolean,
  onSuccess: (data: PaymentPollingDto[]) => void
) => {
  const apiClient = useApiClient();
  return useQuery({
    enabled,

    queryFn: async () => {
      const response = await apiClient.PaymentPollingController.getPaymentStatusList(
        { references: paymentReferences },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      onSuccess(response);
      return response;
    },

    queryKey: ['polling', [...paymentReferences].sort().join(',')],

    refetchInterval: 5000,
  });
};
